import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/(public)/course-info/components/hero/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/partials/modal/notify-me/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/partials/recommend-us/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/app/node_modules/next/dist/client/app-dir/link.js");
